export const Layout = (props) => {
  const {
    avatar_url,
    bio,
    company,
    followers,
    following,
    created_at,
    name,
    login,
    public_repos,
    twitter_username,
    blog,
    location,
    html_url,
  } = props;
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const time = new Date(created_at);
  let day = time.getDate();
  if (day < 10) {
    day = `0${time.getDate()}`;
  } else {
    day = `${time.getDate()}`;
  }
  const month = months[time.getMonth()];
  const year = time.getFullYear();
  return (
    <>
      <section className="layout">
        <div className="lay-img">
          <img src={avatar_url} alt={login + "github avatar"} />
        </div>

        <div className="content">
          <div className="username">
            <div className="user">
              <h2>{name}</h2>
              <h4>
                <a href={html_url} target="_blank" rel="noreferrer">
                  {"@" + login}
                </a>
              </h4>
            </div>
            <div className="joined">
              <p>{`Joined ${day} ${month} ${year}`}</p>
            </div>
          </div>
          <div className="bio">
            <p>{bio || "This profile has no bio"}</p>
          </div>
          <div className="follow">
            <div className="repo">
              <h3>Repos</h3>
              <p>{public_repos}</p>
            </div>
            <div className="repo">
              <h3>Followers</h3>
              <p>{followers}</p>
            </div>
            <div className="repo">
              <h3>Following</h3>
              <p>{following}</p>
            </div>
          </div>

          <div className="contact">
            <div className="con1">
              <div className="social">
                <svg
                  style={{ width: "24px", height: "24px" }}
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z"
                  />
                </svg>
                <p>{location || "Not Available"}</p>
              </div>
              <div className="social">
                <svg
                  style={{ width: "24px", height: "24px" }}
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M10.59,13.41C11,13.8 11,14.44 10.59,14.83C10.2,15.22 9.56,15.22 9.17,14.83C7.22,12.88 7.22,9.71 9.17,7.76V7.76L12.71,4.22C14.66,2.27 17.83,2.27 19.78,4.22C21.73,6.17 21.73,9.34 19.78,11.29L18.29,12.78C18.3,11.96 18.17,11.14 17.89,10.36L18.36,9.88C19.54,8.71 19.54,6.81 18.36,5.64C17.19,4.46 15.29,4.46 14.12,5.64L10.59,9.17C9.41,10.34 9.41,12.24 10.59,13.41M13.41,9.17C13.8,8.78 14.44,8.78 14.83,9.17C16.78,11.12 16.78,14.29 14.83,16.24V16.24L11.29,19.78C9.34,21.73 6.17,21.73 4.22,19.78C2.27,17.83 2.27,14.66 4.22,12.71L5.71,11.22C5.7,12.04 5.83,12.86 6.11,13.65L5.64,14.12C4.46,15.29 4.46,17.19 5.64,18.36C6.81,19.54 8.71,19.54 9.88,18.36L13.41,14.83C14.59,13.66 14.59,11.76 13.41,10.59C13,10.2 13,9.56 13.41,9.17Z"
                  />
                </svg>
                <p>{blog || "Not Available"}</p>
              </div>
            </div>
            <div className="con2">
              <div className="social">
                <svg
                  style={{ width: "24px", height: "24px" }}
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M22.46,6C21.69,6.35 20.86,6.58 20,6.69C20.88,6.16 21.56,5.32 21.88,4.31C21.05,4.81 20.13,5.16 19.16,5.36C18.37,4.5 17.26,4 16,4C13.65,4 11.73,5.92 11.73,8.29C11.73,8.63 11.77,8.96 11.84,9.27C8.28,9.09 5.11,7.38 3,4.79C2.63,5.42 2.42,6.16 2.42,6.94C2.42,8.43 3.17,9.75 4.33,10.5C3.62,10.5 2.96,10.3 2.38,10C2.38,10 2.38,10 2.38,10.03C2.38,12.11 3.86,13.85 5.82,14.24C5.46,14.34 5.08,14.39 4.69,14.39C4.42,14.39 4.15,14.36 3.89,14.31C4.43,16 6,17.26 7.89,17.29C6.43,18.45 4.58,19.13 2.56,19.13C2.22,19.13 1.88,19.11 1.54,19.07C3.44,20.29 5.7,21 8.12,21C16,21 20.33,14.46 20.33,8.79C20.33,8.6 20.33,8.42 20.32,8.23C21.16,7.63 21.88,6.87 22.46,6Z"
                  />
                </svg>
                <p>{twitter_username || "Not Available"}</p>
              </div>
              <div className="social">
                <svg
                  style={{ width: "24px", height: "24px" }}
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M18,15H16V17H18M18,11H16V13H18M20,19H12V17H14V15H12V13H14V11H12V9H20M10,7H8V5H10M10,11H8V9H10M10,15H8V13H10M10,19H8V17H10M6,7H4V5H6M6,11H4V9H6M6,15H4V13H6M6,19H4V17H6M12,7V3H2V21H22V7H12Z"
                  />
                </svg>
                <p>{company || "Not Available"}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
